<template>
  <ul class="m-pagination" v-if="total > 1">
    <li
      class="m-pagination__item m-pagination__item--first"
      :class="{ 'is-hidden': 1 === current || 1 === previous }"
    >
      <router-link class="m-pagination__link first" :to="pageUrl(1)"
        >1</router-link
      >
    </li>

    <li :class="{ 'm-pagination__item': true, 'is-hidden': !previous }">
      <router-link
        class="m-pagination__link previous"
        :to="pageUrl(previous)"
        >{{ previous }}</router-link
      >
    </li>

    <li class="m-pagination__item">
      <router-link class="m-pagination__link current" :to="pageUrl(current)">{{
        current
      }}</router-link>
    </li>

    <li :class="{ 'm-pagination__item': true, 'is-hidden': !next }">
      <router-link class="m-pagination__link next" :to="pageUrl(next)">{{
        next
      }}</router-link>
    </li>

    <li
      class="m-pagination__item m-pagination__item--last"
      :class="{ 'is-hidden': total === current || total === next }"
    >
      <router-link class="m-pagination__link last" :to="pageUrl(total)">{{
        total
      }}</router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    current: Number,
    total: Number,
  },
  computed: {
    previous() {
      if (this.current === 1) {
        return null;
      }
      return this.current - 1;
    },
    next() {
      if (this.current === this.total) {
        return null;
      }
      return this.current + 1;
    },
  },
  methods: {
    pageUrl: function (pageNumber) {
      const query = this.$route.query;

      // map the query object for all params other than page
      const params = Object.keys(query)
        .filter((key) => key !== "page")
        .map((key) => `${key}=${query[key]}`);

      // finally add the page
      params.push(`page=${pageNumber}`);

      return `?${params.join("&")}`;
    },
  },
};
</script>
